import { Avatar, Box, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid2, IconButton, InputLabel, Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from "@mui/material"
import { useDeleteEventHistoryMutation, useOverAllCandidateMutation, useViewCandidateHistoryMutation } from "../../redux/candidateprofiles/candidateprofiles.api"
import { useContext, useEffect, useState } from "react"
import dayjs from "dayjs";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import CloseIcon from "@mui/icons-material/Close";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import ArrowDownwardSharpIcon from "@mui/icons-material/ArrowDownwardSharp";
import ArrowUpwardSharpIcon from "@mui/icons-material/ArrowUpwardSharp";
import { useSelector } from "react-redux";
import { LuHistory } from "react-icons/lu";
import CreateNewFolderOutlinedIcon from "@mui/icons-material/CreateNewFolderOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { BsDownload } from "react-icons/bs";
import { TableLoader } from "../../reusable_components/components/TableLoader";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import MuiDatePicker from "../../reusable_components/components/MuiDatePicker";
import { CalendarIcon } from "lucide-react";
import DeleteIcon from "../../assets/Icons/DeleteIcon";
import MUIButton from "../../reusable_components/components/MUIButton";
import { set } from "react-hook-form";


const AllCandidates = ({ search }) => {

    const commonFilter = JSON.parse(localStorage.getItem("commonsearchfilter"));
    const { Profile } = useSelector((state) => state.common);
    const userRole = Profile?.profile?.role;
    const navigate = useNavigate();
    const { Snackbar } = useContext(SnackbarContext);

    const [page, setPage] = useState(
        +localStorage.getItem("candidateProfileNewPage") || 1
    );
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [sortingColumnDirection, setSortingColumnDirection] = useState("DESC");
    const [mobile, setMobile] = useState(
        commonFilter?.candidateProfiles?.mobileOrAlternateMobile || ""
    );
    // const [search, setSearch] = useState(
    //     localStorage.getItem("candidateProfileSearchValue") || ""
    // );
    const [location, setLocation] = useState(
        commonFilter?.candidateProfiles?.address || ""
    );
    const [email, setEmail] = useState(
        commonFilter?.candidateProfiles?.emailOrAlternateEmail || ""
    );
    const [fromDate, setFromDate] = useState(
        commonFilter?.candidateProfiles?.fromDate
            ? dayjs(commonFilter?.candidateProfiles?.fromDate)
            : null
    );
    const [toDate, setToDate] = useState(
        commonFilter?.candidateProfiles?.toDate
            ? dayjs(commonFilter?.candidateProfiles?.toDate)
            : null
    );
    const [sourcedBy, setSourcedBy] = useState(
        commonFilter?.candidateProfiles?.sourcedBy || ""
    );
    const [selectedKeywordIds, setSelectedKeywordIds] = useState(
        commonFilter?.candidateProfiles?.technologies || []
    );
    const [showTableLoader, setShowTableLoader] = useState(false);
    const [candidatesDatas, setCandidatesDatas] = useState([]);
    const [showClearFilter, setShowClearFilter] = useState(false);
    const [triggerApi, setTriggerApi] = useState(false);
    const [technologies, setTechnologies] = useState("");
    const [selectedKeywords, setSelectedKeywords] = useState([]);
    const [filterDialogOpen, setFilterDialogOpen] = useState(false);
    const [arrow, setArrow] = useState(false);
    const [count, setCount] = useState(0);
    const [openpostions, setoPenPostions] = useState(false);
    const [profileId, setProfileId] = useState("");
    const [open, setOpen] = useState(false);
    const [candidateHistory, setCandiateHistory] = useState([]);
    const [historytableLoder, setHistorytableLoder] = useState(false);
    const [shouldFetch, setShouldFetch] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [MinihistoryDialogOpen, setMinihistoryDialogOpen] = useState(false);
    const [deleteId, setDeleteId] = useState([]);
    const [profileMatchId, setProfileMatchId] = useState();

    // API's
    const [overAllCandidates] = useOverAllCandidateMutation()
    const [viewcandidateHistory] = useViewCandidateHistoryMutation();
    const [deleteHistory] = useDeleteEventHistoryMutation();

    const getAllCandidates = async () => {
        setShowTableLoader(true)
        try {
            const params = {
                // sortingColumn: "",
                sortingDirection: sortingColumnDirection || "",
                address: location,
                technologies: selectedKeywordIds.join(","),
                mobileOrAlternateMobile: mobile,
                emailOrAlternateEmail: email,
                sourceBy: sourcedBy,
                namePhoneEmailSearch: search,
                fromDate: fromDate ? dayjs(fromDate)?.format("YYYY-MM-DD") : "",
                toDate: toDate ? dayjs(toDate)?.format("YYYY-MM-DD") : "",
                page: page - 1 || 0,
                size: rowsPerPage ? rowsPerPage : 10,
            };

            const response = await overAllCandidates(params).unwrap()
            setCandidatesDatas(response?.response?.data)
            setCount(response?.response?.Count)
            setShowTableLoader(false)
            // setTriggerApi(false);
            setOpen(false)

        } catch (error) {
            console.error("Network error", 'error');
            setShowTableLoader(false)
        }
    }

    // useEffect(() => {
    //     getAllCandidates()
    // }, [])

    useEffect(() => {
        getAllCandidates()
        setTriggerApi(false);
    }, [triggerApi , search])

    useEffect(() => {
        if (shouldFetch) {
            letsFilterDatas()
            setShouldFetch(false);
            setTriggerApi(true);
            setFilterDialogOpen(false);
        }
    }, [shouldFetch]);

    const handleOpenFillterDialog = () => {
        setFilterDialogOpen(true);
    };

    const handleclearFilterState = () => {
        setTechnologies("");
        setMobile("");
        setLocation("");
        setEmail("");
        setFromDate(null);
        setToDate(null);
        setSourcedBy("");
        setTriggerApi(true);
        setShowClearFilter(false);
        localStorage.setItem(
            "commonsearchfilter",
            JSON.stringify({ ...commonFilter, candidateProfiles: {} })
        );
    };

    const handleSorting = (e) => {
        if (!arrow) {
            setSortingColumnDirection("ASC");
            setArrow(true);
            setTriggerApi(true);
        } else {
            setSortingColumnDirection("DESC");
            setArrow(false);
            setTriggerApi(true);
        }
    };

    const handleCandidateNav = (row) => {
        navigate(`/candidate-view/${row?.profileId}`, {
            state: {
                profileAssignedJob: row?.profileAssignedJob,
            },
        });
        // navigate(`/editcandidateprofile/${row.profileId}`)
    };

    const addPosition = (profileId) => {
        setoPenPostions(true);
        setProfileId(profileId);
    };

    const handleChangePage = (event, newPage) => {
        localStorage.setItem("candidateProfileNewPage", newPage);
        setPage(newPage);
        setTriggerApi(true);
    };


    const manage_Events = (row) => {
        navigate(`/manage-events-candidate/${row?.profileId}`, {
            state: {
                profileId: row?.profileId,
                firstName: row.firstName,
                lastName: row.lastName,
                email: row.email,
                mobile: row.mobile,
                remarks: row.remarks,
            },
        });
    };

    const handleGetLocation = (e) => {
        setLocation(e.target.value);
        const value = e.target.value;

        const currentFilter =
            JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

        const updatedFilter = {
            ...currentFilter,
            candidateProfiles: {
                ...currentFilter.candidateProfiles,
                address: value,
            },
        };

        localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
    };

    const hanldeFromDate = (value) => {
        if (toDate && toDate <= value) {
            setToDate(null);
        }
        setFromDate(value);

        const currentFilter =
            JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

        const updatedFilter = {
            ...currentFilter,
            candidateProfiles: {
                ...currentFilter.candidateProfiles,
                fromDate: value,
            },
        };

        localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
    };

    const handleTodate = (value) => {
        setToDate(value);

        const currentFilter =
            JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

        const updatedFilter = {
            ...currentFilter,
            candidateProfiles: {
                ...currentFilter.candidateProfiles,
                toDate: value,
            },
        };

        localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
    };

    const getNextDay = (fromDate) => {
        if (!fromDate) {
            return null;
        }
        return dayjs(fromDate)?.add(1, "day");
    };

    const handleSourcedBy = (e) => {
        setSourcedBy(e.target.value);
        const value = e.target.value;

        const currentFilter =
            JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

        const updatedFilter = {
            ...currentFilter,
            candidateProfiles: {
                ...currentFilter.candidateProfiles,
                sourcedBy: value,
            },
        };

        localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
    };
    const [chips, setChips] = useState([]);

    const letsFilterDatas = () => {
        const updateChip = [
            {
                label: location,
                onDelete: () => {
                    setLocation("");
                    localStorage.setItem(
                        "commonsearchfilter",
                        JSON.stringify({
                            ...commonFilter,
                            candidateProfiles: {
                                ...commonFilter.candidateProfiles,
                                address: "",
                            },
                        })
                    );
                    setTriggerApi(true);
                    setChips((prevChips) =>
                        prevChips?.filter((chips) => chips?.label !== location)
                    );
                },
            },
            {
                label: mobile,
                onDelete: () => {
                    setMobile("");
                    localStorage.setItem(
                        "commonsearchfilter",
                        JSON.stringify({
                            ...commonFilter,
                            candidateProfiles: {
                                ...commonFilter.candidateProfiles,
                                mobileOrAlternateMobile: "",
                            },
                        })
                    );
                    setTriggerApi(true);
                    setChips((prevChips) =>
                        prevChips?.filter((chips) => chips?.label !== mobile)
                    );
                },
            },
            {
                label: email,
                onDelete: () => {
                    setEmail("");
                    localStorage.setItem(
                        "commonsearchfilter",
                        JSON.stringify({
                            ...commonFilter,
                            candidateProfiles: {
                                ...commonFilter.candidateProfiles,
                                emailOrAlternateEmail: "",
                            },
                        })
                    );
                    setTriggerApi(true);
                    setChips((prevChips) =>
                        prevChips?.filter((chips) => chips?.label !== email)
                    );
                },
            },
            ...selectedKeywords?.map((item) => ({
                label: item?.keywordName,
                onDelete: () => {
                    setSelectedKeywordIds((prevIds) =>
                        prevIds.filter((id) => id !== item?.KeywordId)
                    );
                    setTriggerApi(true);
                    setChips((prevChips) =>
                        prevChips?.filter((chip) => chip?.label !== item?.keywordName)
                    );
                },
            })),
            fromDate && {
                label: fromDate ? dayjs(fromDate)?.format("DD-MM-YYYY") : "",
                onDelete: () => {
                    setFromDate(null);
                    localStorage.setItem(
                        "commonsearchfilter",
                        JSON.stringify({
                            ...commonFilter,
                            candidateProfiles: {
                                ...commonFilter.candidateProfiles,
                                fromDate: null,
                            },
                        })
                    );
                    setTriggerApi(true);
                    setToDate(null);
                    setChips((prevChips) =>
                        prevChips?.filter(
                            (chips) => chips?.label !== dayjs(fromDate)?.format("DD-MM-YYYY")
                        )
                    );
                },
            },
            toDate && {
                label: toDate ? dayjs(toDate)?.format("DD-MM-YYYY") : "",
                onDelete: () => {
                    setToDate(null);
                    localStorage.setItem(
                        "commonsearchfilter",
                        JSON.stringify({
                            ...commonFilter,
                            candidateProfiles: {
                                ...commonFilter.candidateProfiles,
                                toDate: null,
                            },
                        })
                    );
                    setTriggerApi(true);
                    setChips((prevChips) =>
                        prevChips?.filter(
                            (chips) => chips?.label !== dayjs(toDate)?.format("DD-MM-YYYY")
                        )
                    );
                },
            },
            {
                label: sourcedBy,
                onDelete: () => {
                    setSourcedBy("");
                    localStorage.setItem(
                        "commonsearchfilter",
                        JSON.stringify({
                            ...commonFilter,
                            candidateProfiles: {
                                ...commonFilter.candidateProfiles,
                                sourcedBy: "",
                            },
                        })
                    );
                    setTriggerApi(true);
                    setChips((prevChips) =>
                        prevChips?.filter((chips) => chips?.label !== sourcedBy)
                    );
                },
            },
        ].filter(Boolean);

        setChips(updateChip);
        setTriggerApi(true);
        setShowClearFilter(true);
    };

    const viewHistory = async (profileId) => {
        setOpen(true);
        try {
            const payload = {
                profileId: profileId,
                positionId: 0,
                page: page - 1,
                size: 5000,
            };
            const response = await viewcandidateHistory(payload)?.unwrap();
            if (response) {
                setCandiateHistory(response?.response?.eventHistory);
                setHistorytableLoder(true);
            }
        } catch (error) {
            Snackbar("Network error", "error");
        }
    };

    const formatDate = (date = new Date()) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    };

    useEffect(() => {
        const candidateProfiles = commonFilter?.candidateProfiles;
        const hasValue =
            candidateProfiles &&
            Object.values(candidateProfiles)?.some(
                (value) =>
                    value !== 0 && value !== null && value !== undefined && value !== ""
            );

        if (hasValue) {
            setShouldFetch(true);
        }
    }, []);

    const deleteEventHistory = async (item) => {
        if (isDelete === true) {
            try {
                const payload = {
                    eventHistoryIds: [deleteId] || [],
                    profileMatchId: profileMatchId,
                };

                const response = await deleteHistory(payload).unwrap();
                setMinihistoryDialogOpen(false);
                setOpen(false);

                Snackbar(response?.response?.message, "success");
            } catch (error) {
                Snackbar("Network error", "error");
            }
        } else {
            Snackbar("Network error", "error");
        }
    };

    const handleCloseFilterDialog = () => {
        setFilterDialogOpen(false);
        const hasValue = chips?.some((item) => item?.label);
        if (!hasValue) {
            setLocation("");
            setTechnologies("");
            setMobile("");
            setSourcedBy("");
            setEmail("");
            setProfileId("");
            setFromDate(null);
            setToDate(null);
            localStorage.setItem(
                "commonsearchfilter",
                JSON.stringify({ ...commonFilter, candidateProfiles: {} })
            );
        }
    };

    const handleClose = () => {
        setOpen(false);
        setCandiateHistory([]);
        setHistorytableLoder(false);
    };

    const hanldeMiniDialogOpen = (item) => {
        setMinihistoryDialogOpen(true);
        setProfileMatchId(item?.profileMatchId);
        setDeleteId(item?.eventHistoryId);
        setIsDelete(item?.deletable);
    };

    return (
        <Box>
            <Paper
                sx={{
                    width: "100%",
                    overflow: "auto",
                    marginTop: "10px",
                    border: "1px solid #E9EAEB",
                    borderRadius: "10px",
                }}
                elevation={0}
            >
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell colSpan={100} sx={{ padding: "5px" }}>
                                <Box
                                    sx={{ display: "flex", justifyContent: "space-between" }}
                                >
                                    <div>
                                        {showClearFilter &&
                                            chips?.map(
                                                (chip, index) =>
                                                    chip?.label && (
                                                        <Chip
                                                            variant="outlined"
                                                            size="small"
                                                            className="Chip"
                                                            key={index}
                                                            label={chip?.label}
                                                            deleteIcon={
                                                                <CloseIcon
                                                                    sx={{ color: "#414651 !important" }}
                                                                />
                                                            }
                                                            onDelete={chip?.onDelete}
                                                        />
                                                    )
                                            )}
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            gap: "14px",
                                        }}
                                    >
                                        <MUICancelButton
                                            title="More Filters"
                                            onClick={handleOpenFillterDialog}
                                            startIcon={
                                                <FilterListOutlinedIcon
                                                    sx={{ fontSize: "14px !important" }}
                                                />
                                            }
                                            sx={{
                                                color: "#6941C6",
                                                borderColor: "#D6BBFB",
                                                fontWeight: 600,
                                                width: "130px",
                                            }}
                                        />
                                        {(location ||
                                            technologies ||
                                            mobile ||
                                            email ||
                                            fromDate ||
                                            toDate ||
                                            sourcedBy) &&
                                            showClearFilter && (
                                                <MUICancelButton
                                                    title="Clear filter"
                                                    onClick={handleclearFilterState}
                                                    sx={{ width: "100px" }}
                                                />
                                            )}
                                    </div>
                                </Box>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            {/* <TableCell className='tableHeadersCell_2' >Id</TableCell> */}
                            <TableCell
                                className="tableHeadersCell_2"
                                onClick={handleSorting}
                            >
                                <Typography
                                    sx={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        fontSize: "12px",
                                        cursor: "pointer",
                                        fontFamily: "sans-serif",
                                        fontWeight: 550,
                                    }}
                                >
                                    Name
                                    {arrow ? (
                                        <ArrowDownwardSharpIcon sx={{ fontSize: "18px" }} />
                                    ) : (
                                        <ArrowUpwardSharpIcon sx={{ fontSize: "16px" }} />
                                    )}
                                </Typography>
                            </TableCell>
                            <TableCell className="tableHeadersCell_2">Location</TableCell>
                            {/* <TableCell className='tableHeadersCell_2'>Technologies</TableCell> */}
                            <TableCell className="tableHeadersCell_2">
                                Phone / Alternate Phn{" "}
                            </TableCell>
                            <TableCell className="tableHeadersCell_2">
                                Email / Alternate Email{" "}
                            </TableCell>
                            <TableCell className="tableHeadersCell_2">
                                Sourced By
                            </TableCell>
                            {/* <TableCell className='tableHeadersCell_2'>Is Referral</TableCell> */}
                            <TableCell className="tableHeadersCell_2" align="center">
                                Created Date
                            </TableCell>
                            {/* <TableCell className='tableHeadersCell_2' align='left'>Status</TableCell> */}
                            {userRole === "recruiter" ? (
                                ""
                            ) : (
                                <TableCell
                                    className="tableHeadersCell_2"
                                    align="center"
                                    sx={{ width: "100px" }}
                                >
                                    Action
                                </TableCell>
                            )}
                        </TableRow>
                    </TableHead>
                    {!showTableLoader ? (
                        candidatesDatas?.length > 0 ? (
                            <TableBody>
                                {candidatesDatas?.map((row, index) => {
                                    const colors = [
                                        "green",
                                        "darkorange",
                                        "purple",
                                        "#3357FF",
                                        "orangered",
                                        "darkgreen",
                                        "pink",
                                    ];
                                    const backgroundColor = colors[index % colors?.length];
                                    const techNames = row?.technologies?.map((item) => {
                                        return item.itemName?.trim();
                                    });
                                    const twoTechs = techNames?.slice(0, 2);
                                    const aboveTwoTechs = techNames?.slice(2);
                                    return (
                                        <TableRow
                                            hover
                                            tabIndex={-1}
                                            key={row.code}
                                            sx={{
                                                backgroundColor:
                                                    index % 2 === 1 ? "#FAFAFA" : "inherit",
                                                "&:hover": { backgroundColor: "#f1f1f1" },
                                            }}
                                        >
                                            {/* <TableCell onClick={() => handleCandidateNav(row)} className="tableBodyCell" sx={{ color: '#53389E', fontWeight: 'bold', fontSize: '14px', cursor: 'pointer' }} align='left'>{row.profileId}</TableCell> */}
                                            <TableCell
                                                className="tableBodyCells"
                                                onClick={() => handleCandidateNav(row)}
                                                sx={{ cursor: "pointer", position: "relative" }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        gap: "10px",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <Typography className="tableBodyCells" noWrap>
                                                        <span
                                                            style={{
                                                                color: "#53389E",
                                                                fontWeight: 600,
                                                                fontSize: "12px",
                                                                position: "relative",
                                                                display: "inline-block",
                                                                marginTop: "10px",
                                                            }}
                                                        >
                                                            {row?.firstName}{" "}
                                                            <span>
                                                                {row?.lastName}
                                                                {row?.profileAssignedJob === "No" && (
                                                                    <span
                                                                        style={{
                                                                            backgroundColor: "#53389E",
                                                                            color: "white",
                                                                            fontSize: "10px",
                                                                            fontWeight: 600,
                                                                            padding: "1px 6px",
                                                                            borderRadius: "16px",
                                                                            position: "relative",
                                                                            bottom: "10px",
                                                                            left: "5px",
                                                                            fontSize: "10px",
                                                                            width: "auto",
                                                                            borderColor: "black",
                                                                        }}
                                                                    >
                                                                        <span
                                                                            style={{
                                                                                height: "6px",
                                                                                width: "6px",
                                                                                backgroundColor: "white", // or any color you prefer
                                                                                borderRadius: "50%",
                                                                                display: "inline-block",
                                                                                marginRight: "5px",
                                                                            }}
                                                                        ></span>
                                                                        New
                                                                    </span>
                                                                )}
                                                            </span>
                                                        </span>
                                                        <br />
                                                        <span>
                                                            {row.referralPosition === "" ? (
                                                                ""
                                                            ) : (
                                                                <>{row.referralPosition}</>
                                                            )}
                                                        </span>
                                                    </Typography>
                                                </Box>
                                            </TableCell>
                                            <TableCell
                                                className="tableBodyCells"
                                                sx={{ color: "#181D27" }}
                                            >
                                                {row.address}
                                            </TableCell>
                                            {/* <TableCell className='tableBodyCells' sx={{ color: "#181D27" }}>
                                    <Tooltip
                                      slotProps={{
                                        tooltip: {
                                          sx: {
                                            backgroundColor: "#0A0D12",
                                            borderRadius: '8px',
                                            padding: '8px 12px',
                                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                          }
                                        }
                                      }}
                                      title={aboveTwoTechs?.join(', ')} arrow placement='top'>
                                      {aboveTwoTechs?.length > 0 ? `${twoTechs?.join(', ')} and ${aboveTwoTechs?.length} more` : twoTechs?.join(', ')}
                                    </Tooltip>
                                  </TableCell> */}
                                            <TableCell
                                                className="tableBodyCells"
                                                sx={{ color: "#181D27" }}
                                            >
                                                {" "}
                                                {row.mobile}/<br />
                                                {row.alternateMobile || "NA"}
                                            </TableCell>
                                            <TableCell
                                                className="tableBodyCells"
                                                sx={{ color: "#181D27" }}
                                            >
                                                {" "}
                                                {row.email}/<br />
                                                {row.alternateEmail || "NA"}
                                            </TableCell>
                                            <TableCell className="tableBodyCells">
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        gap: "5px",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <Avatar
                                                        alt={row?.firstName || "NA"}
                                                        sx={{
                                                            width: "32px",
                                                            height: "32px",
                                                            backgroundColor: backgroundColor,
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        {row?.sourceName?.charAt(0)?.toUpperCase() ||
                                                            "?"}
                                                    </Avatar>
                                                    <Typography
                                                        className="tableBodyCells"
                                                        sx={{ color: "#181D27" }}
                                                    >
                                                        {row?.sourceName}
                                                        {row?.isReferral !== "N" && (
                                                            <span
                                                                style={{
                                                                    color: "#5417cd",
                                                                    fontWeight: 600,
                                                                    marginLeft: "4px",
                                                                }}
                                                            >
                                                                (BA)
                                                            </span>
                                                        )}
                                                        <br></br>
                                                        <span style={{ color: "#535862" }}>
                                                            {row?.sourceBy}
                                                        </span>
                                                    </Typography>
                                                </Box>
                                            </TableCell>
                                            {/* <TableCell className="tableBodyCell" sx={{ Color: '#181D27' }}>{row?.isReferral === "N" ? 'No' : 'Yes'}</TableCell> */}
                                            <TableCell
                                                className="tableBodyCells"
                                                sx={{ color: "#535862" }}
                                                align="center"
                                            >
                                                {" "}
                                                {formatDate(row.createdDate)}
                                            </TableCell>
                                            {/* <TableCell className="tableBodyCells" >
                                        <span className={`candidateStatus-badge ${row?.status?.toLowerCase()}`}>
                                          {row.status === "Active"
                                            ? "Approved"
                                            : row.status === "Inactive"
                                              ? "Rejected"
                                              : row.status === "Pending"
                                                ? "Pending"
                                                : ""}
                                        </span>
                                      </TableCell> */}
                                            {userRole === "recruiter" ? (
                                                ""
                                            ) : (
                                                <TableCell
                                                    className="tableBodyCells"
                                                    sx={{ minWidth: "100px", whiteSpace: "nowrap" }}
                                                >
                                                    <Tooltip
                                                        title="History"
                                                        slotProps={{
                                                            tooltip: {
                                                                sx: {
                                                                    backgroundColor: "#0A0D12",
                                                                    borderRadius: "8px",
                                                                    padding: "8px 12px",
                                                                    boxShadow:
                                                                        "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                                                },
                                                            },
                                                        }}
                                                    >
                                                        <span>
                                                            <LuHistory
                                                                onClick={
                                                                    row?.status === "Active"
                                                                        ? () => viewHistory(row?.profileId)
                                                                        : null
                                                                }
                                                                style={{
                                                                    fontSize: "17px",
                                                                    margin: "5px",
                                                                    cursor:
                                                                        row?.status === "Active"
                                                                            ? "pointer"
                                                                            : "not-allowed",
                                                                    color: "#b6bbbb",
                                                                    transition:
                                                                        "transform 0.2s ease, color 0.2s ease",
                                                                }}
                                                                onMouseOver={(e) => {
                                                                    if (row?.status === "Active") {
                                                                        e.currentTarget.style.color = "#5417cd";
                                                                        e.currentTarget.style.transform =
                                                                            "scale(1.2)";
                                                                    }
                                                                }}
                                                                onMouseOut={(e) => {
                                                                    e.currentTarget.style.color = "#b6bbbb";
                                                                    e.currentTarget.style.transform =
                                                                        "scale(1)";
                                                                }}
                                                            />
                                                        </span>
                                                    </Tooltip>
                                                    <Tooltip
                                                        title={
                                                            row?.cvPath !== null
                                                                ? "Profile Download"
                                                                : "No profile uploaded for this candidate."
                                                        }
                                                        slotProps={{
                                                            tooltip: {
                                                                sx: {
                                                                    backgroundColor: "#0A0D12",
                                                                    borderRadius: "8px",
                                                                    padding: "8px 12px",
                                                                    boxShadow:
                                                                        "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                                                },
                                                            },
                                                        }}
                                                    >
                                                        <span>
                                                            <BsDownload
                                                                // onClick={
                                                                //     row?.cvPath !== null
                                                                //         ? () => handleDownload(row?.cvPath)
                                                                //         : null
                                                                // }
                                                                style={{
                                                                    fontSize: "17px",
                                                                    margin: "5px",
                                                                    cursor:
                                                                        row?.cvPath === null
                                                                            ? "not-allowed"
                                                                            : "pointer",
                                                                    color: "#b6bbbb",
                                                                    transition:
                                                                        row?.cvPath === null
                                                                            ? ""
                                                                            : "transform 0.2s ease, color 0.2s ease",
                                                                }}
                                                                onMouseOver={(e) => {
                                                                    e.currentTarget.style.color =
                                                                        row?.cvPath === null
                                                                            ? "black"
                                                                            : "#5417cd";
                                                                    e.currentTarget.style.transform =
                                                                        row?.cvPath === null
                                                                            ? ""
                                                                            : "scale(1.2)";
                                                                }}
                                                                onMouseOut={(e) => {
                                                                    e.currentTarget.style.color = "#b6bbbb";
                                                                    e.currentTarget.style.transform =
                                                                        "scale(1)";
                                                                }}
                                                            />
                                                        </span>
                                                    </Tooltip>
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        ) : (
                            <TableBody>
                                <TableRow>
                                    <TableCell colSpan={10}>
                                        <Typography className="emptydatas">
                                            No Data Found
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        )
                    ) : (
                        <TableRow>
                            <TableCell colSpan={13}>
                                <Box className="tableloader">
                                    <TableLoader />
                                </Box>
                            </TableCell>
                        </TableRow>
                    )}
                    <TableRow>
                        {count <= rowsPerPage ? (
                            ""
                        ) : (
                            <TableCell colSpan={100}>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <MUICancelButton
                                        title="Previous"
                                        startIcon={
                                            <ArrowBackIcon
                                                sx={{ color: page === 1 ? "#a2a2a2" : "#414651" }}
                                            />
                                        }
                                        disabled={page === 1}
                                        onClick={() => handleChangePage(null, page - 1)}
                                        sx={{ height: "36px" }}
                                    />
                                    <Pagination
                                        page={page}
                                        onChange={handleChangePage}
                                        count={Math.ceil(count / rowsPerPage)}
                                        siblingCount={3}
                                        boundaryCount={3}
                                        shape="rounded"
                                        hidePrevButton
                                        hideNextButton
                                    />

                                    <MUICancelButton
                                        title="Next"
                                        startIcon={
                                            <ArrowForwardIcon
                                                sx={{
                                                    color:
                                                        page === Math.ceil(count / rowsPerPage)
                                                            ? "#a2a2a2"
                                                            : "#414651",
                                                }}
                                            />
                                        }
                                        disabled={page === Math.ceil(count / rowsPerPage)}
                                        onClick={() => handleChangePage(null, page + 1)}
                                        sx={{ height: "36px" }}
                                    />
                                </div>
                            </TableCell>
                        )}
                    </TableRow>
                </Table>
            </Paper>

            <Grid2 item>
                <Dialog
                    open={filterDialogOpen}
                    scroll="paper"
                    maxWidth="md"
                    className="sidePopup"
                >
                    <DialogTitle
                        sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                        <Typography sx={{ fontWeight: 600, fontSize: "18px" }}>
                            Filters
                        </Typography>
                        <CloseIcon
                            onClick={() => setFilterDialogOpen(false)}
                            sx={{ cursor: "pointer" }}
                        />
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <Grid2
                                container
                                rowGap={2}
                                sx={{ display: "flex", width: "100%" }}
                            >
                                {/* Container 1 */}

                                <Box sx={{ width: "100%" }}>
                                    <InputLabel className="input"> Location </InputLabel>
                                    <TextField
                                        className="textfields"
                                        size="small"
                                        placeholder="Search By Location"
                                        value={location || ""}
                                        onChange={handleGetLocation}
                                    />
                                </Box>

                                {/* <Box sx={{ width: "100%" }}>
                              <InputLabel className="input"> Technologies </InputLabel>
                              <TextField
                                className="textfields"
                                size="small"
                                placeholder="Search Technologies"
                                value={technologies || ""}
                                onChange={handleTechnologies}
                              />
                            </Box> */}

                                {/* <Box sx={{ width: "100%" }}>
                              <InputLabel className="input"> Mobile </InputLabel>
                              <TextField
                                className="textfields"
                                size="small"
                                placeholder=" Search By Mobile"
                                value={mobile || ""}
                                onChange={handleMobile}
                              />
                            </Box>
            
                            <Box sx={{ width: "100%" }}>
                              <InputLabel className="input"> Candidate Email </InputLabel>
                              <TextField
                                className="textfields"
                                size="small"
                                placeholder="Search by Candidate Email"
                                value={email}
                                onChange={handleEmail}
                              />
                            </Box> */}

                                {/* <Box sx={{ width: "100%" }}>
                              <InputLabel className="input">Candidate Skills</InputLabel>
                              <Select
                                IconComponent={KeyboardArrowDownIcon}
                                className='dropdown'
                                sx={{ height: '35px', fontSize: '14px', borderRadius: '10px' }}
                                multiple
                                value={selectedKeywordIds}
                                onChange={handleCheckboxChanges}
                                displayEmpty
                                open={opencandidateSkills}
                                onOpen={() => setOpencandidateSkills(true)}
                                onClose={() => setOpencandidateSkills(false)}
                                renderValue={(selected) => selected?.length < 1
                                  ? <p style={{ color: '#a2a2a2', fontSize: '14px' }}>Select Candidate Skills</p>
                                  : selectedKeywords?.map((item) => item?.keywordName)?.join(', ')
                                }
                              >
                                <Box className='selectClearButton'>
                                  <MenuItem value='' className="menuItemsPlaceholder" disabled>
                                    Select Candidate Skills
                                  </MenuItem>
                                  <Tooltip title="Close" arrow>
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setOpencandidateSkills(false);
                                      }}
                                      onMouseDown={(e) => e.preventDefault()}
                                    >
                                      <ClearIcon sx={{ fontSize: '18px', color: '#a2a2a2' }} />
                                    </IconButton>
                                  </Tooltip>
                                </Box>
                                {skills?.map((keyword) => (
                                  <MenuItem key={keyword?.KeywordId} value={keyword?.KeywordId} sx={{ margin: '5px', borderRadius: '7px', fontSize: '14px' }}>
                                    <Checkbox
                                      checked={selectedKeywordIds?.includes(keyword?.KeywordId)}
                                      sx={{ '& .MuiSvgIcon-root': { fontSize: 18 }, padding: 0.2 }}
                                    />
                                    {keyword?.keywordName}
                                  </MenuItem>
                                ))}
                              </Select>
                            </Box> */}

                                <Box sx={{ width: "100%" }}>
                                    <InputLabel className="input">From Date</InputLabel>
                                    <MuiDatePicker
                                        value={fromDate}
                                        onChange={hanldeFromDate}
                                        slots={{
                                            openPickerIcon: CalendarIcon,
                                        }}
                                        slotProps={{
                                            textField: {
                                                size: "small",
                                                placeholder: "Choose By From Date",
                                                InputProps: {
                                                    sx: { borderRadius: "10px", height: "35px" },
                                                },
                                            },
                                        }}
                                        sx={{
                                            "& .MuiInputBase-input": {
                                                fontSize: "14px",
                                            },
                                            "& .MuiSvgIcon-root": {
                                                fontSize: "20px",
                                            },
                                        }}
                                        format="DD-MM-YYYY"
                                    />
                                </Box>
                                <Box sx={{ width: "100%" }}>
                                    <InputLabel className="input">To Date</InputLabel>
                                    <MuiDatePicker
                                        value={toDate}
                                        onChange={handleTodate}
                                        slots={{
                                            openPickerIcon: CalendarIcon,
                                        }}
                                        slotProps={{
                                            textField: {
                                                size: "small",
                                                placeholder: "Choose By To Date",
                                                InputProps: {
                                                    sx: { borderRadius: "10px", height: "35px" },
                                                },
                                            },
                                        }}
                                        sx={{
                                            "& .MuiInputBase-input": {
                                                fontSize: "14px",
                                            },
                                            "& .MuiSvgIcon-root": {
                                                fontSize: "20px",
                                            },
                                        }}
                                        format="DD-MM-YYYY"
                                        minDate={getNextDay(fromDate) || null}
                                        maxDtae={dayjs()}
                                        disabled={!fromDate}
                                    />
                                </Box>

                                <Box sx={{ width: "100%" }}>
                                    <InputLabel className="input"> Sourced By </InputLabel>
                                    <TextField
                                        className="textfields"
                                        size="small"
                                        placeholder=" Search Sourced By"
                                        value={sourcedBy || ""}
                                        onChange={handleSourcedBy}
                                    />
                                </Box>
                            </Grid2>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Grid2
                            item
                            sx={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                gap: "20px",
                            }}
                        >
                            <MUICancelButton
                                title="Cancel"
                                sx={{ width: "42%" }}
                                onClick={handleCloseFilterDialog}
                            />
                            <MUIButton
                                title="Apply"
                                sx={{ width: "42%" }}
                                onClick={() => {
                                    setPage(1);
                                    setShouldFetch(true);
                                }}
                            />
                        </Grid2>
                    </DialogActions>
                </Dialog>

                <Grid2 item>
                    <Dialog
                        open={MinihistoryDialogOpen}
                        scroll="paper"
                        maxWidth="xs"
                        sx={{
                            "& .MuiDialog-paper": {
                                width: "90%",
                                maxWidth: "550px",
                                height: "auto",
                                borderRadius: "15px",
                            },
                        }}
                    >
                        <DialogContent>
                            <DialogContentText>
                                <div style={{ display: "flex", gap: "12px", marginTop: "7px" }}>
                                    <div
                                        style={{
                                            backgroundColor: "#FEE4E2",
                                            borderRadius: "40px",
                                            height: "40px",
                                            width: "45px",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <DeleteIcon stroke={"red"} />
                                    </div>

                                    <div>
                                        <Typography
                                            sx={{
                                                color: "#181D27",
                                                fontWeight: 600,
                                                fontSize: "17px",
                                            }}
                                        >
                                            Delete Job?
                                        </Typography>
                                        <Typography
                                            sx={{
                                                color: "#535862",
                                                fontWeight: 400,
                                                fontSize: "14px",
                                            }}
                                        >
                                            Are you sure you want to delete this post? This action
                                            cannot be undone.
                                        </Typography>
                                    </div>
                                </div>
                                <Grid2
                                    item
                                    sx={{
                                        marginTop: "25px",
                                        display: "flex",
                                        gap: "10px",
                                        justifyContent: "flex-end",
                                    }}
                                >
                                    <MUICancelButton
                                        title="Cancel"
                                        onClick={() => setMinihistoryDialogOpen(false)}
                                    />
                                    <MUIButton
                                        title="Delete"
                                        sx={{
                                            backgroundColor: "#D92D20",
                                            borderRadius: "10px",
                                            cursor: "pointer",
                                        }}
                                        onClick={deleteEventHistory}
                                    />
                                </Grid2>
                            </DialogContentText>
                        </DialogContent>
                    </Dialog>
                </Grid2>
            </Grid2>

            <Grid2>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    scroll="paper"
                    maxWidth="md"
                    sx={{
                        "& .MuiDialog-paper": {
                            minHeight: "85vh",
                            minWidth: "70vw",
                        },
                        marginLeft: "70px",
                    }}
                >
                    <DialogTitle variant="h6">
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                            }}
                        >
                            <Typography sx={{ fontWeight: 600, fontSize: "18px" }}>
                                History
                            </Typography>
                            <CloseIcon
                                sx={{ cursor: "pointer" }}
                                onClick={handleClose}
                            ></CloseIcon>
                        </Box>
                    </DialogTitle>
                    <DialogContent dividers>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="tableHeadersCell">Date </TableCell>
                                        <TableCell className="tableHeadersCell">
                                            Client Name{" "}
                                        </TableCell>
                                        <TableCell className="tableHeadersCell">
                                            Job Title{" "}
                                        </TableCell>
                                        <TableCell className="tableHeadersCell">Event </TableCell>
                                        <TableCell className="tableHeadersCell">Notes </TableCell>
                                        <TableCell className="tableHeadersCell">
                                            Processed By{" "}
                                        </TableCell>
                                        <TableCell className="tableHeadersCell">Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                {historytableLoder ? (
                                    candidateHistory.length > 0 ? (
                                        <TableBody>
                                            {candidateHistory.map((item, index) => (
                                                <TableRow
                                                    key={index}
                                                    sx={{
                                                        backgroundColor:
                                                            index % 2 === 1 ? "#FAFAFA" : "inherit",
                                                        "&:hover": { backgroundColor: "#f1f1f1" },
                                                    }}
                                                >
                                                    <TableCell className="tableBodyCell">
                                                        {formatDate(item.date)}
                                                    </TableCell>
                                                    <TableCell className="tableBodyCell">
                                                        {item.clientName}
                                                    </TableCell>
                                                    <TableCell className="tableBodyCell">
                                                        {item.jobTitile}
                                                    </TableCell>
                                                    <TableCell className="tableBodyCell">
                                                        {item.event}
                                                    </TableCell>
                                                    <TableCell className="tableBodyCell">
                                                        {item.notes}
                                                    </TableCell>

                                                    <TableCell className="tableBodyCell">
                                                        {item.processedBy}
                                                    </TableCell>
                                                    <TableCell className="tableBodyCell">
                                                        <Tooltip
                                                            slotProps={{
                                                                tooltip: {
                                                                    sx: {
                                                                        backgroundColor: "#0A0D12",
                                                                        borderRadius: "8px",
                                                                        padding: "8px 12px",
                                                                        boxShadow:
                                                                            "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                                                    },
                                                                },
                                                            }}
                                                            title={item?.deletable ? "Delete" : ""}
                                                        >
                                                            <IconButton
                                                                sx={{ color: item?.deletable && "#fd5c63" }}
                                                                disabled={!item?.deletable}
                                                                onClick={(e) =>
                                                                    item?.deletable && hanldeMiniDialogOpen(item)
                                                                }
                                                            >
                                                                <DeleteIcon
                                                                    stroke={item?.deletable ? "red" : "#a2a2a2"}
                                                                    style={{
                                                                        cursor: !item?.deletable && "not-allowed",
                                                                        pointerEvents: "auto",
                                                                    }}
                                                                />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    ) : (
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={10}>
                                                    <Typography className="emptydatas">
                                                        No Data Found
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    )
                                ) : (
                                    <TableCell colSpan={100}>
                                        <Box className="tableloader">
                                            <TableLoader />
                                        </Box>
                                    </TableCell>
                                )}
                            </Table>
                        </TableContainer>
                    </DialogContent>
                    <DialogActions>
                        <MUICancelButton onClick={handleClose} title="Close">
                            Close
                        </MUICancelButton>
                    </DialogActions>
                </Dialog>
            </Grid2>
        </Box>
    )
}

export default AllCandidates;